export default __webpack_public_path__ + "static/media/ic_row-empty.80f5a3dd.svg";